import { useRef, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import "@/assets/sass/footer.scss";

function OfficialFooter(props) {
  const { t } = useTranslation();
  let buyPop = useRef();
  let [buyObj, setBuyObj] = useState({
    name: "Nvidia 1995TF_#1001",
    description:
      "Traditional color format systems required a lot of memories and energy. But this invention use only one frame buffer which makes system more efficient.",
  });
  useEffect(() => {
    $(buyPop.current).on("params", (e, params) => {
      if (params) {
        params = JSON.parse(params);
        setBuyObj(params);
      }
    });
  }, []);
  return (
    <>
      {/* Start Footer */}
      <div className="cs-footer">
        <div className="container">
          {/* <div className="row top">
            <div className="col-12  ">
              <h3 className="GmarketSans weight400">
                Best Patent NFT를 거래하려면
                <br></br>
                암호화폐 지갑을 연결하세요
              </h3>
              <button className="footer-btn GmarketSans weight400">
                지갑연결
              </button>
            </div>
          </div> */}
          <div className="row GmarketSans weight400">
            <div className="col-12 ">
              <div className="flex footer-flex">
                <div className="logo" style={{ fontWeight: 300 }}>
                  <img
                    style={{ marginLeft: "-10px", marginBottom: "18px", height: 40, width: 'fit-content' }}
                    src="/assets/img/footerlogo.png"
                    alt=""
                  />
                  <div
                    style={{
                      color: "#A8B6AF",
                      fontSize: "12px",
                      lineHeight: "1.5",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: t("footer.logoTip"),
                    }}
                  ></div>
                  <p
                    style={{ color: "#576059", fontSize: "10px", marginBottom:0 }}
                    className="tip"
                  >
                    {t("footer.copyright")}
                  </p>
                  <p
                    style={{ color: "#ffffff", fontSize: "12px", marginBottom: "25px" }}
                    className="tip"
                  >
                    <a href="https://www.nts.go.kr" target="_blank">
                        [국세청]
                    </a>&nbsp;/&nbsp;
                    <a href="https://www.acrc.go.kr" target="_blank">
                        [국민권익위원회]
                    </a>&nbsp;/&nbsp;
                    <a href="https://me.go.kr/" target="_blank">
                        [환경부]
                    </a>
                  </p>
                  <div className="line d-md-none"></div>
                </div>
                <div className="footer-nav-list flex flex-1">
                  <ol className="nav-group">
                    <li className="title">
                      <a href="#/privacy-policy">
                        {t("components.privacy_policy")}
                      </a>
                    </li>

                  </ol>
                  <ol className="nav-group">
                    <li className="title"> <a href="#/terms-condition">
                      {t("components.terms_of_service")}
                    </a></li>

                  </ol>
                  <ol className="nav-group">
                    <li className="title">
                      <a href="#/refund-terms">
                        {t("components.refund_terms")}
                      </a>
                    </li>
                  </ol>
                  <ol className="nav-group">
                    <li className="title">
                      <a href="#/contact">
                        {t("about.contact_us")}
                      </a>
                    </li>

                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Footer */}

      {/* Start Modal */}
      <div className="cs-modal_wrap" id="history_1">
        <div className="cs-modal_overlay"></div>
        <div className="cs-modal_container">
          <div className="cs-modal_container_in">
            <div className="cs-modal_close cs-center">
              <svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.9649 2.54988C12.3554 2.15936 12.3554 1.52619 11.9649 1.13567C11.5744 0.745142 10.9412 0.745142 10.5507 1.13567L11.9649 2.54988ZM0.550706 11.1357C0.160181 11.5262 0.160181 12.1594 0.550706 12.5499C0.94123 12.9404 1.5744 12.9404 1.96492 12.5499L0.550706 11.1357ZM1.96492 1.13567C1.5744 0.745142 0.94123 0.745142 0.550706 1.13567C0.160181 1.52619 0.160181 2.15936 0.550706 2.54988L1.96492 1.13567ZM10.5507 12.5499C10.9412 12.9404 11.5744 12.9404 11.9649 12.5499C12.3554 12.1594 12.3554 11.5262 11.9649 11.1357L10.5507 12.5499ZM10.5507 1.13567L0.550706 11.1357L1.96492 12.5499L11.9649 2.54988L10.5507 1.13567ZM0.550706 2.54988L10.5507 12.5499L11.9649 11.1357L1.96492 1.13567L0.550706 2.54988Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div className="cs-history">
              <h2 className="cs-history_title">Bidding History</h2>
              <ul className="cs-history_list">
                <li>
                  <div className="cs-media cs-style1">
                    <div className="cs-media_thumb">
                      <img src="/assets/img/avatar/avatar_1.png" alt="" />
                    </div>
                    <div className="cs-media_info">
                      <h3 className="cs-media_title">
                        Bid accepted <span>9 ETH</span> by @raymond
                      </h3>
                      <div className="cs-media_subtitle">
                        16 Mar 2022, 11:22 PM
                      </div>
                    </div>
                    <div className="cs-media_icon cs-center">
                      <svg
                        width="14"
                        height="15"
                        viewBox="0 0 14 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M4.12813 0.361363C3.64827 0.462564 3.27024 0.673413 2.90257 1.04494C2.65338 1.29672 2.54141 1.46434 2.39635 1.80267C2.23387 2.18165 2.21897 2.32007 2.21897 3.45088V4.46376H1.56184C1.03057 4.46376 0.885293 4.47185 0.803425 4.50609C0.673732 4.56026 0.586696 4.64212 0.519539 4.7731C0.470648 4.86845 0.446202 5.23207 0.233603 9.0251C0.105742 11.3064 0.00787787 13.2467 0.0161084 13.3369C0.036261 13.5577 0.182989 13.8537 0.347409 14.0053C0.41637 14.0689 0.555004 14.1598 0.655439 14.2074L0.838097 14.2939L3.18528 14.3015L5.53246 14.3091L5.44999 14.1648C5.31489 13.9283 5.22339 13.6155 5.20827 13.3382C5.1894 12.9924 5.511 8.44622 5.57009 8.22367C5.59401 8.13346 5.65155 7.98851 5.69792 7.9015C5.7974 7.71488 6.07382 7.44587 6.26646 7.34825C6.53541 7.21197 6.66385 7.19901 7.7493 7.19857L8.75419 7.19816L8.75463 7.12296C8.75485 7.08162 8.72958 6.57403 8.69846 5.99502C8.63661 4.84436 8.62436 4.77231 8.46467 4.61719C8.32486 4.48142 8.22511 4.46376 7.59819 4.46376H7.03641L7.02487 3.40418C7.01426 2.43147 7.00857 2.32734 6.95553 2.1341C6.60643 0.862169 5.38491 0.0963178 4.12813 0.361363ZM4.91416 1.15702C5.46205 1.2557 5.96198 1.71019 6.14532 2.27624C6.18754 2.40661 6.19545 2.56209 6.20466 3.44519L6.2153 4.46376H6.62568H7.03603L7.02695 4.94036C7.01872 5.37092 7.0124 5.42422 6.96146 5.49239C6.7697 5.74898 6.44007 5.75533 6.27327 5.50562C6.2147 5.41796 6.2112 5.38599 6.2112 4.93823V4.46376H4.62751H3.0438L3.03472 4.94036C3.02649 5.37092 3.02018 5.42422 2.96923 5.49239C2.77747 5.74898 2.44784 5.75533 2.28104 5.50562C2.22247 5.41796 2.21897 5.38599 2.21897 4.93823V4.46376H2.62913H3.03929V3.49439C3.03929 2.45168 3.04935 2.34895 3.17989 2.05926C3.32389 1.73978 3.60151 1.45143 3.92308 1.28737C4.19198 1.15018 4.58751 1.09818 4.91416 1.15702ZM6.66237 8.06992C6.52992 8.13133 6.44666 8.21793 6.39027 8.35284C6.33966 8.474 6.00757 13.0062 6.0281 13.2959C6.06157 13.7681 6.38174 14.1505 6.84301 14.2693C6.973 14.3028 7.46508 14.3076 10.0833 14.3013L13.1702 14.2939L13.3529 14.2074C13.4533 14.1598 13.5916 14.0691 13.6602 14.0059C13.8118 13.8662 13.9662 13.5698 13.9907 13.3714C14.0013 13.2853 13.9412 12.2675 13.8408 10.8349C13.6522 8.14407 13.673 8.28314 13.433 8.11443L13.3159 8.03215L10.0438 8.02567C6.90718 8.01949 6.76721 8.02133 6.66237 8.06992ZM8.98377 9.31092C9.15842 9.41106 9.19169 9.50668 9.19169 9.9085C9.19169 10.3577 9.23296 10.4949 9.42642 10.6896C9.67117 10.9358 10.0178 10.9837 10.3211 10.8134C10.619 10.6461 10.723 10.4096 10.723 9.89937C10.723 9.52782 10.7527 9.42673 10.8908 9.32823C11.0125 9.24136 11.2314 9.2369 11.3413 9.31902C11.5118 9.44628 11.5289 9.49541 11.5383 9.8866C11.5538 10.5265 11.424 10.9037 11.0638 11.2651C10.5795 11.7512 9.89454 11.869 9.27662 11.5727C9.09511 11.4856 9.0034 11.4184 8.83835 11.2513C8.48625 10.8948 8.37269 10.5776 8.37184 9.94804C8.37146 9.6501 8.37996 9.57663 8.42584 9.48185C8.52945 9.26783 8.77656 9.19214 8.98377 9.31092Z"
                          fill="#050023"
                        />
                      </svg>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="cs-media cs-style1">
                    <div className="cs-media_thumb">
                      <img src="/assets/img/avatar/avatar_1.png" alt="" />
                    </div>
                    <div className="cs-media_info">
                      <h3 className="cs-media_title">Followed by @jessica</h3>
                      <div className="cs-media_subtitle">
                        16 Mar 2022, 11:22 PM
                      </div>
                    </div>
                    <div className="cs-media_icon cs-center">
                      <svg
                        width="18"
                        height="15"
                        viewBox="0 0 18 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M4.30703 0.343803C2.41054 0.658409 1.04224 1.9741 0.632295 3.8773C0.527867 4.36213 0.528991 5.25496 0.634675 5.74646C0.77519 6.40003 1.06233 7.04371 1.49036 7.6646C1.81811 8.14007 2.05846 8.42368 2.62089 8.9987C3.37898 9.77368 4.13281 10.427 5.7909 11.7459C6.27078 12.1276 7.18971 12.8603 7.833 13.3742L9.00259 14.3086L9.73643 13.719C10.14 13.3947 11.0205 12.6929 11.693 12.1593C13.795 10.4915 14.5802 9.8172 15.4113 8.96572C16.5449 7.80439 17.1302 6.83975 17.3645 5.74646C17.4631 5.28628 17.4717 4.39686 17.3819 3.94802C17.1855 2.96577 16.7386 2.13739 16.057 1.49221C15.4581 0.925328 14.7327 0.553881 13.8741 0.374404C13.46 0.287855 12.5053 0.286797 12.1128 0.372455C10.9435 0.627741 9.95867 1.32764 9.22467 2.42496C9.11462 2.58947 9.01336 2.7241 8.99968 2.7241C8.986 2.7241 8.88356 2.58771 8.77209 2.42103C8.04747 1.33772 7.06314 0.634747 5.90981 0.376949C5.5804 0.303321 4.66516 0.284385 4.30703 0.343803Z"
                          fill="#050023"
                        />
                      </svg>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="cs-media cs-style1">
                    <div className="cs-media_thumb">
                      <img src="/assets/img/avatar/avatar_3.png" alt="" />
                    </div>
                    <div className="cs-media_info">
                      <h3 className="cs-media_title">Created by @federico</h3>
                      <div className="cs-media_subtitle">
                        05 Mar 2022, 11:22 PM
                      </div>
                    </div>
                    <div className="cs-media_icon cs-center">
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M1.82881 0.353422C1.13833 0.504993 0.510112 1.01963 0.206167 1.68271C-0.0102227 2.15472 -0.00737581 2.09596 0.00423016 5.85783C0.0159456 9.66714 -0.00117138 9.39188 0.256678 9.9132C0.537667 10.4812 1.10811 10.9452 1.74761 11.1257C1.97016 11.1886 2.19915 11.1927 5.45203 11.1927H8.91922L9.19295 11.1076C9.59368 10.983 9.90756 10.7943 10.1996 10.5023C10.4916 10.2102 10.6804 9.89634 10.8049 9.4956L10.89 9.22188V5.75469C10.89 1.88074 10.9033 2.09388 10.6296 1.57183C10.3319 1.00398 9.84872 0.604702 9.19295 0.384773C9.00411 0.321451 8.78696 0.317035 5.52502 0.310283C2.69499 0.30448 2.01575 0.3124 1.82881 0.353422ZM12.8747 2.73619C12.7326 2.81042 12.6496 2.88659 12.5694 3.01615L12.4594 3.19415L12.4412 7.04744L12.4229 10.9007L12.3417 11.138C12.1036 11.8343 11.5317 12.4062 10.8353 12.6444L10.5981 12.7256L6.74766 12.7438L2.89726 12.7621L2.72488 12.8634C2.42072 13.0422 2.27287 13.4123 2.36656 13.7602C2.42367 13.9722 2.66415 14.2116 2.88021 14.2714C3.00624 14.3064 3.91278 14.3141 6.8754 14.3053L10.7076 14.2939L11.0644 14.1959C12.4756 13.8084 13.5058 12.7788 13.8927 11.3692L13.9912 11.0102L14.0026 7.17806C14.0114 4.21544 14.0037 3.30889 13.9688 3.18287C13.9115 2.97619 13.681 2.74002 13.4771 2.6791C13.2457 2.60994 13.0877 2.62494 12.8747 2.73619ZM5.6447 3.44353C5.87853 3.5024 6.13496 3.75882 6.19383 3.99266C6.2174 4.08627 6.23671 4.34449 6.23671 4.56646V4.97001L6.70204 4.97081C7.23453 4.97172 7.38278 5.01661 7.57443 5.23486C7.90334 5.60947 7.80322 6.18484 7.3665 6.42988C7.22041 6.51185 7.15504 6.5224 6.72379 6.53375L6.24372 6.54637L6.23109 7.02645C6.21974 7.4577 6.20919 7.52306 6.12722 7.66916C5.99006 7.91362 5.7763 8.0473 5.49389 8.0653C5.23429 8.08183 5.05268 8.01208 4.87914 7.82924C4.70509 7.64584 4.66735 7.49748 4.66735 6.99674V6.53937H4.2638C3.7196 6.53937 3.56128 6.49521 3.35069 6.28458C2.96645 5.90035 3.05912 5.3057 3.54066 5.06574C3.71789 4.97742 3.76894 4.97001 4.20004 4.97001H4.66735V4.5027C4.66735 4.0716 4.67476 4.02054 4.76308 3.84332C4.86545 3.63787 5.05093 3.48594 5.25991 3.43638C5.43174 3.39561 5.4563 3.39608 5.6447 3.44353Z"
                          fill="#050023"
                        />
                      </svg>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* End Modal */}

      {/* Start Modal */}
      <div className="cs-modal_wrap" id="bid_1" ref={buyPop}>
        <div className="cs-modal_overlay"></div>
        <div className="cs-modal_container">
          <div className="cs-modal_container_in">
            <div className="cs-modal_close cs-center">
              <svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.9649 2.54988C12.3554 2.15936 12.3554 1.52619 11.9649 1.13567C11.5744 0.745142 10.9412 0.745142 10.5507 1.13567L11.9649 2.54988ZM0.550706 11.1357C0.160181 11.5262 0.160181 12.1594 0.550706 12.5499C0.94123 12.9404 1.5744 12.9404 1.96492 12.5499L0.550706 11.1357ZM1.96492 1.13567C1.5744 0.745142 0.94123 0.745142 0.550706 1.13567C0.160181 1.52619 0.160181 2.15936 0.550706 2.54988L1.96492 1.13567ZM10.5507 12.5499C10.9412 12.9404 11.5744 12.9404 11.9649 12.5499C12.3554 12.1594 12.3554 11.5262 11.9649 11.1357L10.5507 12.5499ZM10.5507 1.13567L0.550706 11.1357L1.96492 12.5499L11.9649 2.54988L10.5507 1.13567ZM0.550706 2.54988L10.5507 12.5499L11.9649 11.1357L1.96492 1.13567L0.550706 2.54988Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div className="cs-bid_card">
              <h2 className="cs-title_title">{buyObj.name}</h2>
              <div className="cs-bid_info">
                <ul>
                  <li>
                    <span>Current Balance</span>
                    <b>13.45ETH</b>
                  </li>
                  <li>
                    <span>{t("components.price")}</span>
                    <b>0.28ETH</b>
                  </li>
                </ul>
                <div className="cs-height_20 cs-height_lg_20"></div>
                <p>{buyObj.description}</p>
                <div className="cs-height_25 cs-height_lg_25"></div>
                <button className="cs-btn cs-style1 cs-btn_lg w-100">
                  <span>{t("components.purchase")}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Modal */}

      {/* Start Video Popup */}
      <div className="cs-video_popup">
        <div className="cs-video_popup_overlay"></div>
        <div className="cs-video_popup_content">
          <div className="cs-video_popup_layer"></div>
          <div className="cs-video_popup_container">
            <div className="cs-video_popup_align">
              <div className="embed-responsive embed-responsive-16by9">
                <iframe
                  className="embed-responsive-item"
                  src="about:blank"
                ></iframe>
              </div>
            </div>
            <div className="cs-video_popup_close"></div>
          </div>
        </div>
      </div>
      {/* End Video Popup */}

      {/* Start Modal */}
      <div className="cs-modal_wrap" id="to_login">
        <div className="cs-modal_overlay"></div>
        <div className="cs-modal_container">
          <div className="cs-modal_container_in">
            <div className="cs-modal_close cs-center">
              <svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.9649 2.54988C12.3554 2.15936 12.3554 1.52619 11.9649 1.13567C11.5744 0.745142 10.9412 0.745142 10.5507 1.13567L11.9649 2.54988ZM0.550706 11.1357C0.160181 11.5262 0.160181 12.1594 0.550706 12.5499C0.94123 12.9404 1.5744 12.9404 1.96492 12.5499L0.550706 11.1357ZM1.96492 1.13567C1.5744 0.745142 0.94123 0.745142 0.550706 1.13567C0.160181 1.52619 0.160181 2.15936 0.550706 2.54988L1.96492 1.13567ZM10.5507 12.5499C10.9412 12.9404 11.5744 12.9404 11.9649 12.5499C12.3554 12.1594 12.3554 11.5262 11.9649 11.1357L10.5507 12.5499ZM10.5507 1.13567L0.550706 11.1357L1.96492 12.5499L11.9649 2.54988L10.5507 1.13567ZM0.550706 2.54988L10.5507 12.5499L11.9649 11.1357L1.96492 1.13567L0.550706 2.54988Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div className="cs-bid_card">
              <h2 className="cs-title_title">{t("exploreDetails.notice")}</h2>
              <div className="cs-bid_info">
                <p>{t("exploreDetails.login_required")}</p>
                <div className="cs-height_25 cs-height_lg_25"></div>
                <div className="row">
                  <div className="col-6">
                    <button className="cs-btn cs-style1 cs-btn_lg  w-100 cs-btn_close">
                      <span>{t("exploreDetails.cancel")}</span>
                    </button>
                  </div>
                  <div className="col-6">
                    <Link to="/login">
                      <button className="cs-btn cs-style1 cs-btn_lg cs-btn_close  w-100">
                        <span>{t("exploreDetails.login")}</span>
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default connect((state) => {
  return {
    isLogin: state.isLogin,
    language: state.language,
  };
})(OfficialFooter);
